import React, { Component } from 'react';

import BoxSize from '../../style/styledComponents/BoxSize';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import Header from '../../Components/Header';
import { setWaitCampaign } from '../../_redux/actions/campaign';
import VivoSuccessImg from '../../img/vivosucesso.svg';
import VivoLogo from '../../img/logo_vivo2x.png';
import { ThemeProvider } from 'styled-components';
import ThemeSelector from '../../style/themes/ThemeSelector';
import NavBtn from '../../Components/NavBtn';
import TitleListSubscribers from '../../style/styledComponents/TtleListSubscribers';

class VivoSuccess extends Component {
	constructor() {
		super();

		this.state = {
			loja: null
		};
		this.sendCode = this.sendCode.bind(this);
	}

	componentDidMount() {
		if (window.jQuery) {
			let $ = window.jQuery;
		}
	}

	sendCode() {
		let { loja } = this.props.match.params;
		//let loja = 'yalo';
		this.props.history.push(process.env.PUBLIC_URL + `/${loja}/beneficiario`);
	}

	render() {
		const { VivoUser } = this.props;
		const signatureType = VivoUser.data.signature_type;
		const pathArray = window.location.pathname.split('/');
		return (
			<ThemeProvider theme={ThemeSelector(pathArray[2])}>
				<div className='page-wrapper'>
					<div className=' footer-adjustment'>
						<Header {...this.props} />

						<BoxSize className='box-content-width-success2'>
							<img
								className='visible-xs visible-sm'
								src={VivoLogo}
								style={{
									width: 100,

									marginTop: 30,
									marginBottom: 30
								}}
							/>
							<img src={VivoSuccessImg} className='visible-xs visible-sm' />

							<img
								src={VivoLogo}
								style={{
									width: 100,
									marginTop: 30,
									marginBottom: 30
								}}
								className=' visible-md visible-lg'
							/>
							<img src={VivoSuccessImg} className=' visible-md visible-lg' />

							<TitleListSubscribers style={{ marginTop: '15px' }}>
								<h3>
									Está tudo certo com sua assinatura! Agora vamos para o
									cadastro!
								</h3>
							</TitleListSubscribers>

							<Link
								to={`/loja/vivoavulso/beneficiario?assinatura=${signatureType}`}>
								<NavBtn
									disabled={this.state.isLoading}
									goForward={this.sendCode}
									goForwardText={'ATIVAR MINHA ASSINATURA'}></NavBtn>
							</Link>
						</BoxSize>
					</div>
				</div>
			</ThemeProvider>
		);
	}
}

const mapStateToProps = actionObject => {
	return actionObject;
};

const mapDispatchToProps = dispatch =>
	bindActionCreators({ setWaitCampaign }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(VivoSuccess);
